import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { useAuth, dashboardPath } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) {
      navigate("/connexion");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        loginWithToken(data.token, data.user);
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Bienvenue ${data.user.name} !`);
        navigate(dashboardPath(data.user.role));
      } catch (e) {
        toast.error(apiError(e));
        navigate("/connexion");
      }
    })();
  }, [navigate, loginWithToken]);

  return (
    <div className="flex min-h-screen items-center justify-center text-slate-500" data-testid="auth-callback">
      Connexion en cours…
    </div>
  );
}
